<script>
import { authMethods } from '@state/helpers';

export default {
  name: 'ResetPassworddesktop',
  components: {},
  data() {
    return {
      email: '',
      resetMessage: '',
      loading: false,
    };
  },
  methods: {
    ...authMethods,
    async onResetPassword() {
      this.loading = true;
      const res = await this.resetPassword({ email: this.email });
      if (!res || !res.data.success || res.status === '400') {
        this.resetMessage = 'Email address was not found';
      }
      if (res && res.success) {
        this.email = '';
        this.resetMessage = res.message;
      }
      this.loading = false;
    },
  },
};
</script>

<template>
  <div class="container">
    <div class="header">
      <div class="title">
        <h1>Enter Your Email</h1>
      </div>
      <div class="subtitle">
        <p>
          Enter your email to receive instructions on how to reset your password.
        </p>
      </div>
    </div>
    <div class="form">
      <form @submit.prevent="onResetPassword">
        <BaseInputTextWithLabel
          id="email"
          type="email"
          classStyle="decorate"
          placeholder=""
          label="Email"
          v-model="email"
        ></BaseInputTextWithLabel>
        <p v-show="resetMessage" class="error">{{ resetMessage }}</p>
        <div class="buttons">
          <div id="send-email">
            <BaseButton class="large" type="submit">
              <p v-if="!loading">Send Email</p>
              <b-spinner v-else small type="grow"></b-spinner>
            </BaseButton>
          </div>
          <div id="other-info">
            <p>
              Or return to
              <router-link class="links" to="/login">Sign In</router-link>
            </p>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-id-pattern
.container {
  align-items: center;
  background: white;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  .header {
    display: flex;
    flex-direction: column;
    margin-bottom: 60px;
    text-align: center;
    width: 100%;

    .title {
      align-self: center;
      font-family: $base-font-family;
      font-size: 42px;
      height: 80px;
      line-height: 80px;
      margin-top: 30px;
    }

    .subtitle {
      align-self: center;
      font-family: $secondary-font-family;
      font-size: 16px;
      font-weight: normal;
      height: 50px;
      margin: 0;
      margin-top: 30px;
      width: 60%;

      p {
        margin: 0;
      }
    }
  }

  .form {
    display: block;
    height: 55%;
    margin: 0;
    text-align: center;
    width: 100%;

    form {
      height: 100%;
      width: 100%;

      #email {
        margin-bottom: 80px;
        margin-left: 17%;
        width: 80%;
      }

      #send-email {
        align-self: flex-end;
        margin-left: 10.25%;
        width: 80.5%;
        .large {
          align-items: center;
          display: flex;
          justify-content: center;
          p {
            margin-bottom: unset;
          }
        }
      }
      .error {
        color: red;
      }
    }
  }
  .buttons {
    bottom: 30px;
    width: 100%;
  }
  #other-info {
    font-family: $secondary-font-family;
    font-size: 16px;
    height: 25%;
    line-height: 1.4;
    margin: 0;
    margin-top: 3.2%;
    text-align: center;

    .links {
      color: #4059e1;
      text-decoration: none;
    }
  }
}
</style>
